import styled from "styled-components";

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 600px 600px;
  grid-row-gap: -10px;

  .player {
    z-index: 5; /* set higher z-index value */
    margin-bottom: -23px;
    padding: none;
  }

  .bottom-row {
    margin-bottom: -15px;
  }
`;
